import { ApiService } from "pwapi";

import {
  AI_OUTPUT_REQUEST,
  SLIDE_CLASSIFICATION_FAILURE,
  SLIDE_CLASSIFICATION_REQUEST,
  SLIDE_CLASSIFICATION_SUCCESS,
  SPECIMEN_CLASSIFICATION_FAILURE,
  SPECIMEN_CLASSIFICATION_REQUEST,
  SPECIMEN_CLASSIFICATION_SUCCESS,
  WIPE_AI,
} from "./constants";
import { AsyncSagaAction, createAsyncSaga } from "../utils/asyncActions";

export const aiOutputRequest = (classificationId: string, nonfatal = false) => {
  return {
    type: AI_OUTPUT_REQUEST,
    payload: { id: classificationId, nonfatal },
  };
};

export const wipeAI = () => ({
  type: WIPE_AI,
  payload: {},
});

type SpecimenClassificationArgs = Parameters<
  typeof ApiService.retrieveSpecimenClassification
>[0];
export const fetchSpecimenClassification = createAsyncSaga(
  SPECIMEN_CLASSIFICATION_REQUEST,
  SPECIMEN_CLASSIFICATION_SUCCESS,
  SPECIMEN_CLASSIFICATION_FAILURE,
  ({ parentLookupCaseId, id }: SpecimenClassificationArgs) =>
    `ai/${parentLookupCaseId}/specimen-classification/${id}/`,
  (args: SpecimenClassificationArgs) =>
    ApiService.retrieveSpecimenClassification(args)
) as AsyncSagaAction<SpecimenClassificationArgs>;

// TODO: should rename retrieveSlideClassification1 to retrieveSlideClassificationv2
type SlideClassificationArgs = Parameters<
  typeof ApiService.retrieveSlideClassification1
>[0] & { slide_id: number }; // slide_id is used in the reducer for organizing state
export const fetchSlideClassification = createAsyncSaga(
  SLIDE_CLASSIFICATION_REQUEST,
  SLIDE_CLASSIFICATION_SUCCESS,
  SLIDE_CLASSIFICATION_FAILURE,
  ({ id, slide_id }: SlideClassificationArgs) =>
    `ai/${slide_id}/slide-classification/${id}`,
  ({ id }: SlideClassificationArgs) =>
    ApiService.retrieveSlideClassification1({ id })
) as AsyncSagaAction<SlideClassificationArgs>;
